import React, { useState, Fragment } from 'react'
import { Modal, Button, Form, Row, Col } from 'react-bootstrap'
import { CircularProgress } from '@material-ui/core'
import { inviteUser } from '../../api/sockets/account/accountRequests'

export const InviteUser = ({show, setShow, socket, notify, props}) => {

    const [email, setEmail] = useState('')
    const [paysHouse, setPaysHouse] = useState(true)
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSubmit = (e) => {        
        e.preventDefault()
        setLoading(true)

        const requestData = {
            TargetEmail: email,
            PaysHouse: paysHouse
        }
        socket.props.setLoading = setLoading
        socket.props.notify = notify
        socket.props.onSuccess = () => {
            props.reloadAccountAccess && props.reloadAccountAccess()
        }
        socket.props.onFailure = () => {
            setError('User Email Not Found')
        }

        inviteUser(requestData, socket)
    }

    return <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Invite User</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
            <Modal.Body>
                {loading
                ? <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%'}}>
                    <CircularProgress style={{width: '100px', height: '100px'}} />
                </div>
                : <Fragment>
                    {error && <Row style={{justifyContent: 'center'}}>
                        <Form.Label style={{color: 'red', fontWeight: 'bold'}}>
                            {error}
                        </Form.Label>
                    </Row>}
                    <Form.Group as={Row}>
                        <Form.Label column xs={3}>
                            Email
                        </Form.Label>
                        <Col>
                            <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} required type="email" />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{justifyContent: 'center', alignItems: 'center'}}>
                        <Form.Check type="switch" id="PaysHouse" label="Pays House" checked={paysHouse} onChange={(e) => setPaysHouse(e.target.checked)} />
                    </Form.Group>
                </Fragment>
            }
            </Modal.Body>
            <Modal.Footer>
                {!loading && <Button variant="success" type="submit">Submit Request</Button>}
            </Modal.Footer>
        </Form>
    </Modal>
}